import { useState, useEffect } from 'react'

export default function PWAInstallPrompt() {
  const [installPrompt, setInstallPrompt] = useState(null)
  const [showBanner, setShowBanner] = useState(false)
  const [isIOS, setIsIOS] = useState(false)
  const [isInstalled, setIsInstalled] = useState(false)

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true)
      return
    }

    // iOS detection
    const ios = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
    setIsIOS(ios)

    // Show iOS banner after 3 seconds if not dismissed before
    if (ios && !localStorage.getItem('pwa-dismissed')) {
      setTimeout(() => setShowBanner(true), 3000)
    }

    // Android/Chrome install prompt
    const handler = (e) => {
      e.preventDefault()
      setInstallPrompt(e)
      if (!localStorage.getItem('pwa-dismissed')) {
        setTimeout(() => setShowBanner(true), 3000)
      }
    }
    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  const handleInstall = async () => {
    if (installPrompt) {
      installPrompt.prompt()
      const { outcome } = await installPrompt.userChoice
      if (outcome === 'accepted') {
        setShowBanner(false)
        setInstallPrompt(null)
      }
    }
  }

  const handleDismiss = () => {
    setShowBanner(false)
    localStorage.setItem('pwa-dismissed', 'true')
  }

  if (isInstalled || !showBanner) return null

  return (
    <div style={{
      position: 'fixed',
      bottom: 20,
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'calc(100% - 32px)',
      maxWidth: 400,
      background: '#0B1E3D',
      border: '1px solid rgba(255,255,255,0.12)',
      borderRadius: 16,
      padding: '16px 18px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
      zIndex: 9999,
      display: 'flex',
      gap: 12,
      alignItems: 'flex-start',
    }}>
      {/* Icon */}
      <div style={{
        width: 48, height: 48, borderRadius: 12,
        background: '#E8614A',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 24, flexShrink: 0,
      }}>
        🌊
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: 'white', marginBottom: 3, fontFamily: 'DM Sans, sans-serif' }}>
          Add WaveSync to Home Screen
        </div>

        {isIOS ? (
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', lineHeight: 1.5, fontFamily: 'DM Sans, sans-serif' }}>
            Tap <strong style={{ color: 'rgba(255,255,255,0.8)' }}>Share</strong> then{' '}
            <strong style={{ color: 'rgba(255,255,255,0.8)' }}>"Add to Home Screen"</strong>
          </div>
        ) : (
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', lineHeight: 1.5, fontFamily: 'DM Sans, sans-serif' }}>
            Install for the full app experience
          </div>
        )}

        {!isIOS && (
          <button
            onClick={handleInstall}
            style={{
              marginTop: 10, background: '#E8614A', border: 'none',
              color: 'white', padding: '8px 18px', borderRadius: 8,
              cursor: 'pointer', fontSize: 13, fontWeight: 700,
              fontFamily: 'DM Sans, sans-serif',
            }}
          >
            Install App
          </button>
        )}
      </div>

      <button
        onClick={handleDismiss}
        style={{
          background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)',
          cursor: 'pointer', fontSize: 18, padding: 0, lineHeight: 1, flexShrink: 0,
        }}
      >
        ×
      </button>
    </div>
  )
}
